import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { Button, Modal, ModalCloseButton, NotificationDispatch } from '@tryhackme/thm-ui-components';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import type { BaseManageUsersData } from 'src/common/interfaces';
import { StyledActionButtonsWrapper, StyledContent, StyledErrorToast, StyledFontAwesomeErrorIcon, StyledText, StyledTitle, StyledWrapper } from 'src/features/admin/manage-users/modals/modals.styles';
import type { BasicModalProps } from '../modal.types';
export const BasicModal = ({
  isOpen,
  setIsOpen,
  userId,
  buttonText,
  warningText,
  mutation,
  title,
  description,
  successMessage,
  buttonColor = 'primary',
  triggerElement
}: BasicModalProps) => {
  const [mutationTrigger, {
    isLoading
  }] = mutation();
  const onBanUser = async () => {
    try {
      await mutationTrigger({
        userId
      } as BaseManageUsersData).unwrap();
      NotificationDispatch('success', successMessage);
      setIsOpen(false);
    } catch (error: unknown) {
      NotificationDispatch('error', isQueryErrorWithMessage(error) ? error.data.message : 'An unknown error has occurred');
    }
  };
  return <Modal open={isOpen} onOpenChange={open => setIsOpen(open)} isSmall triggerElement={triggerElement} data-sentry-element="Modal" data-sentry-component="BasicModal" data-sentry-source-file="basic-modal.tsx">
      <StyledWrapper data-sentry-element="StyledWrapper" data-sentry-source-file="basic-modal.tsx">
        <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="basic-modal.tsx">
          {warningText && <StyledFontAwesomeErrorIcon icon={faExclamationCircle} />}
          {title}
        </StyledTitle>
        <StyledContent data-sentry-element="StyledContent" data-sentry-source-file="basic-modal.tsx">
          <StyledText data-sentry-element="StyledText" data-sentry-source-file="basic-modal.tsx">{description}</StyledText>
          {warningText && <StyledErrorToast>
              <StyledFontAwesomeErrorIcon icon={faExclamationCircle} />
              {warningText}
            </StyledErrorToast>}
        </StyledContent>
        <StyledActionButtonsWrapper data-sentry-element="StyledActionButtonsWrapper" data-sentry-source-file="basic-modal.tsx">
          <ModalCloseButton text="Cancel" data-sentry-element="ModalCloseButton" data-sentry-source-file="basic-modal.tsx" />
          <Button
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick={onBanUser} variant="solid" color={buttonColor} disabled={isLoading} isLoading={isLoading} data-sentry-element="Button" data-sentry-source-file="basic-modal.tsx">
            {buttonText}
          </Button>
        </StyledActionButtonsWrapper>
      </StyledWrapper>
    </Modal>;
};